import { render, staticRenderFns } from "./LocalAtendimentoEditar.vue?vue&type=template&id=b14ec7b0&"
import script from "./LocalAtendimentoEditar.vue?vue&type=script&lang=js&"
export * from "./LocalAtendimentoEditar.vue?vue&type=script&lang=js&"
import style0 from "./LocalAtendimentoEditar.vue?vue&type=style&index=0&id=b14ec7b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports